export type AdapterMode = "mock" | "sandbox" | "production";

export type IntegrationEnv = Record<string, string | undefined>;

export interface AdapterSelectorConfig {
  tenantId: string;
  mode?: AdapterMode;
  provider?: string;
  env?: IntegrationEnv;
}

export class IntegrationNotConfiguredError extends Error {
  constructor(
    readonly category: string,
    readonly provider: string,
    readonly envVars: readonly string[],
  ) {
    super(
      `${provider} ${category} adapter is not configured. Set ${envVars.join(", ")} and implement the production adapter after pilot selection.`,
    );
    this.name = "IntegrationNotConfiguredError";
  }
}

export class IntegrationSuppressedError extends Error {
  constructor(
    readonly category: string,
    readonly provider: string,
    readonly code: string,
    message: string,
  ) {
    super(`${provider} ${category} suppressed: ${message}`);
    this.name = "IntegrationSuppressedError";
  }
}

export function requireIntegrationEnv(
  env: IntegrationEnv | undefined,
  category: string,
  provider: string,
  envVars: readonly string[],
) {
  const missing = envVars.filter((name) => !env?.[name]);
  if (missing.length > 0) {
    throw new IntegrationNotConfiguredError(category, provider, missing);
  }
}
